import React from 'react';

import StudentsPage from '../../academyPages/Students';

function Students(props) {
  return <StudentsPage coachMode history={props.history}/>;
}

export default Students;